import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Components that make up the Change Management Log, which helps the Change Management team implement changes for clients.',
    name: 'Change Impacts',
    partialId: PartialId.Standard.create('change_impacts'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
